import { createUuid } from '@core/utils';

export interface ChatMessageData {
  id: string;
  type: 'user' | 'ai';
  content?: string;
  options?: { value: string; label: string; className?: string }[];
  textCenter?: boolean;
  isMarkdown?: boolean;
  isStreaming?: boolean;
  isCopy?: boolean;
  errorText?: string;
}

export const createMessage = (
  type: ChatMessageData['type'],
  fields: Omit<ChatMessageData, 'id' | 'type'> = {},
): ChatMessageData => ({
  id: `${type}-${createUuid()}`,
  type,
  content: '',
  ...fields,
});
